import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 609.000000 565.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,565.000000) scale(0.100000,-0.100000)" >


<path d="M2595 4487 c-46 -18 -70 -38 -89 -74 l-17 -33 -387 0 c-447 0 -458
-2 -541 -76 -71 -64 -95 -119 -96 -215 0 -84 15 -120 129 -312 l58 -97 -16
-34 c-42 -89 11 -176 108 -176 26 0 44 9 72 35 35 33 36 37 32 85 -7 70 -40
100 -123 112 -33 5 -191 286 -201 356 -12 92 41 187 131 235 39 21 53 22 430
25 215 1 395 -1 400 -5 6 -5 17 -21 27 -38 9 -16 33 -40 55 -52 67 -39 134
-26 187 37 51 61 26 184 -44 216 -41 20 -83 23 -115 11z"/>
<path d="M4236 4484 c-50 -18 -66 -32 -83 -71 l-13 -33 -390 0 c-223 0 -390 4
-390 9 0 5 -13 23 -29 40 -25 27 -36 31 -81 31 -46 0 -56 -4 -86 -34 -40 -40
-45 -90 -14 -140 44 -72 128 -75 191 -7 l37 40 353 1 c195 0 368 -2 384 -6 21
-4 35 -16 45 -37 8 -18 31 -42 50 -55 30 -20 43 -23 89 -19 30 3 57 11 61 17
13 22 44 5 67 -35 39 -69 30 -158 -27 -256 -15 -25 -39 -65 -52 -90 -14 -24
-76 -132 -138 -239 -62 -107 -131 -229 -153 -270 -73 -134 -93 -160 -152 -195
-37 -23 -57 -30 -60 -22 -9 27 -34 115 -47 167 l-15 55 -51 3 -50 3 -21 61
c-12 34 -21 70 -21 80 0 37 -16 16 -27 -34 -6 -29 -16 -65 -22 -81 l-11 -27
-341 2 -340 3 -18 55 c-10 30 -22 69 -26 85 -7 24 -9 26 -12 10 -3 -11 -13
-50 -24 -87 l-20 -68 -48 0 -49 0 -11 -44 c-6 -25 -16 -57 -21 -72 l-11 -27
-30 41 c-19 26 -51 51 -87 69 -56 27 -60 28 -274 31 l-217 4 -3 -63 -3 -62
-35 -2 c-19 -1 -43 -5 -52 -9 -12 -5 -20 -1 -29 16 -7 12 -23 31 -36 41 -30
24 -29 28 8 49 25 15 29 22 23 40 -8 26 -22 38 -46 38 -24 0 -50 -29 -43 -50
8 -27 -6 -31 -51 -15 -21 8 -76 14 -121 15 -89 0 -157 -18 -205 -53 -24 -18
-32 -19 -46 -9 -55 40 -109 55 -209 60 -122 5 -191 -13 -252 -65 -76 -65 -91
-128 -87 -378 4 -192 8 -223 41 -281 53 -92 149 -129 309 -121 55 3 248 6 429
6 l327 0 0 171 0 170 -26 0 c-29 0 -29 -1 5 90 12 30 21 71 21 91 0 39 9 47
50 45 l25 -1 1 -115 c0 -63 1 -190 2 -282 l2 -167 148 -5 c169 -6 157 -6 367
-1 88 3 186 5 218 5 44 0 57 3 57 15 0 8 7 15 15 15 8 0 15 -6 15 -14 0 -19
273 -30 543 -23 177 5 200 8 212 24 13 17 14 17 27 1 12 -16 39 -18 273 -19
143 0 269 2 280 6 35 12 70 30 77 39 4 6 29 -2 60 -19 59 -33 29 -30 393 -29
110 1 238 1 285 1 98 0 135 14 189 72 64 68 75 109 76 267 0 136 -1 143 -29
198 -41 80 -121 136 -196 136 l-31 0 3 85 3 85 -177 0 -177 0 -3 -82 -3 -83
-223 -2 c-122 -1 -227 -5 -232 -8 -5 -3 -26 -3 -47 1 -20 4 -56 7 -81 7 -52 0
-62 15 -35 54 10 15 24 39 31 53 7 14 25 46 41 72 16 25 40 66 54 90 66 117
152 264 248 424 27 45 56 101 64 124 30 85 11 206 -44 276 -14 18 -21 41 -21
71 0 111 -96 184 -194 147z m-2918 -1283 c37 -19 62 -74 62 -132 l0 -54 -50 3
c-48 4 -50 5 -56 38 -9 51 -27 64 -89 64 -78 0 -85 -5 -85 -59 l0 -47 116 -50
c153 -64 166 -80 163 -196 -2 -76 -4 -85 -30 -110 -38 -37 -98 -51 -196 -46
-100 5 -146 33 -163 99 -13 47 -16 96 -7 105 5 5 61 8 104 5 7 -1 12 -17 11
-41 -1 -59 14 -70 87 -70 68 0 86 11 91 57 5 44 -22 68 -119 109 -158 65 -183
94 -174 200 5 67 25 104 67 125 55 27 218 27 268 0z m475 -6 c42 -27 57 -65
57 -145 0 -94 -23 -139 -95 -185 -30 -19 -56 -35 -59 -35 -3 0 -28 -14 -55
-30 -62 -39 -74 -77 -27 -85 17 -4 77 -5 134 -3 l102 3 0 -47 0 -48 -175 -1
c-96 -1 -181 -2 -187 -3 -20 -2 -22 130 -3 179 16 44 42 67 120 109 119 64
135 80 135 148 0 51 -21 68 -85 68 -50 0 -63 -7 -69 -40 -5 -23 -22 -30 -64
-27 l-47 3 1 38 c3 79 46 117 144 125 82 8 137 0 173 -24z m664 19 c48 -7 89
-47 102 -98 6 -25 11 -120 11 -211 0 -184 -7 -214 -59 -258 -32 -27 -33 -27
-191 -27 l-158 0 -1 297 c0 163 3 300 8 303 11 6 242 2 288 -6z m801 7 l163
-1 -3 -47 -3 -48 -67 -3 -68 -3 0 -249 c0 -160 -4 -250 -10 -251 -5 0 -29 -1
-52 -1 l-43 -1 -3 251 -2 252 -65 0 -65 0 0 48 c0 56 2 60 32 56 13 -1 96 -3
186 -3z m1635 0 c15 -1 17 -13 17 -97 0 -88 2 -95 18 -89 33 15 142 18 173 5
53 -22 64 -58 64 -205 0 -148 -12 -182 -74 -211 -38 -18 -143 -15 -236 9 l-50
12 -3 287 c-3 313 -5 298 53 292 11 -1 28 -3 38 -3z m-1972 -36 c10 -46 44
-167 82 -295 54 -182 76 -264 72 -268 -3 -4 -68 -5 -100 -3 -6 1 -18 28 -28
60 l-18 60 -55 7 c-78 9 -96 -2 -111 -66 -7 -29 -14 -54 -16 -56 -6 -6 -117
-11 -117 -5 0 3 18 74 41 156 22 83 53 202 70 265 16 63 34 130 40 148 l11 33
61 -3 c59 -3 61 -4 68 -33z m782 8 c3 -16 12 -50 21 -78 8 -27 23 -81 34 -120
11 -38 38 -134 61 -213 23 -79 41 -148 39 -154 -2 -6 -27 -11 -56 -12 l-52 -1
-21 62 c-19 59 -22 62 -58 68 -45 7 -111 -3 -111 -17 0 -5 -7 -33 -15 -61
l-15 -52 -57 2 c-32 1 -59 2 -59 2 -3 1 80 312 121 456 9 33 21 79 27 103 l10
42 63 0 c60 0 63 -1 68 -27z m749 -311 l3 -167 24 -3 c13 -2 43 4 66 13 54 20
58 33 54 195 l-3 125 47 5 c26 3 52 3 58 0 7 -5 9 -80 7 -220 l-3 -213 -53 -2
c-29 -1 -55 2 -57 6 -3 4 -20 3 -38 -2 -47 -13 -113 -11 -152 5 -58 24 -65 52
-65 249 0 95 2 176 4 178 2 2 27 2 55 1 l51 -4 2 -166z m-263 155 c33 -17 61
-57 64 -91 2 -28 0 -29 -47 -33 -38 -4 -51 -1 -58 11 -7 12 -25 16 -68 16 -80
0 -81 -22 -2 -46 102 -31 148 -54 165 -83 34 -58 12 -156 -41 -181 -36 -17
-197 -13 -232 5 -27 14 -60 68 -60 98 0 24 95 27 115 5 16 -19 109 -26 119 -9
9 14 -4 41 -20 41 -7 0 -49 12 -94 26 -96 30 -120 58 -120 138 0 41 5 53 34
82 34 34 34 34 128 34 54 0 103 -5 117 -13z"/>
<path d="M2282 2918 l3 -203 66 0 c101 0 99 -4 99 206 0 207 4 199 -105 199
l-65 0 2 -202z"/>
<path d="M4950 2931 l-35 -18 0 -93 0 -93 48 -14 c32 -9 53 -11 66 -4 23 13
32 74 24 169 l-6 72 -31 0 c-17 0 -47 -8 -66 -19z"/>
<path d="M2847 2990 c-3 -8 -15 -44 -25 -80 l-20 -65 45 -3 c25 -2 47 -1 49 1
2 2 -7 39 -20 83 -13 43 -26 72 -29 64z m20 -92 c-3 -8 -6 -5 -6 6 -1 11 2 17
5 13 3 -3 4 -12 1 -19z"/>
<path d="M3623 2963 c-4 -16 -8 -30 -8 -33 -1 -3 -5 -12 -8 -20 -4 -8 -8 -26
-9 -40 -3 -23 1 -25 40 -28 23 -2 42 0 42 4 0 14 -41 144 -45 144 -3 0 -8 -12
-12 -27z"/>
<path d="M2912 4414 c-36 -25 -45 -50 -32 -90 29 -86 160 -67 160 23 0 66 -74
105 -128 67z"/>
<path d="M715 2313 c-147 -133 -195 -178 -195 -185 0 -8 86 -116 113 -143 34
-32 86 -65 103 -64 37 1 79 35 103 82 13 26 29 47 35 47 17 0 53 39 64 71 8
19 6 34 -5 57 -9 18 -19 32 -24 32 -5 0 -1 -15 8 -34 15 -33 15 -36 -6 -70
-13 -20 -31 -36 -41 -36 -35 0 -50 -12 -50 -40 0 -33 -40 -76 -78 -83 -24 -5
-37 5 -109 80 -46 47 -83 90 -83 96 0 10 175 184 211 209 16 11 19 17 9 17 -8
0 -33 -16 -55 -36z"/>
<path d="M850 2260 c17 -22 36 -40 42 -40 12 0 -41 66 -60 74 -8 3 1 -12 18
-34z"/>
<path d="M5243 2273 c-27 -11 -11 -21 26 -16 36 5 42 2 105 -58 36 -35 66 -68
66 -75 0 -6 -16 -19 -35 -28 -19 -9 -35 -23 -35 -31 0 -8 -16 -31 -34 -50 -29
-30 -40 -35 -63 -29 -37 9 -73 42 -73 69 0 11 18 41 40 65 44 50 51 71 20 63
-11 -3 -20 -8 -20 -12 0 -4 -16 -23 -36 -44 -29 -29 -40 -35 -50 -26 -21 17
-18 27 26 86 23 29 38 53 35 53 -14 0 -95 -97 -95 -114 0 -11 13 -31 28 -45
16 -14 35 -40 42 -58 15 -34 56 -63 90 -63 34 0 76 30 94 66 8 19 21 34 27 34
10 0 17 6 53 47 18 22 18 23 -26 65 -103 99 -141 119 -185 101z"/>
<path d="M753 2215 c-19 -20 -16 -28 16 -59 52 -50 93 -15 51 44 -23 32 -47
38 -67 15z m57 -48 c0 -6 -9 -2 -20 8 -11 10 -20 23 -20 28 0 6 9 2 20 -8 11
-10 20 -23 20 -28z"/>
<path d="M657 2132 c-25 -27 -21 -44 16 -80 38 -37 62 -41 77 -13 15 29 13 37
-21 76 -35 40 -49 43 -72 17z m47 -34 c13 -14 28 -48 21 -48 -7 0 -55 47 -55
54 0 10 21 7 34 -6z"/>
<path d="M5290 2100 c-22 -30 -20 -50 5 -50 15 0 55 51 55 69 0 22 -39 10 -60
-19z"/>
<path d="M4888 2011 c-27 -24 -30 -31 -20 -44 8 -9 10 -26 6 -42 -7 -30 27
-75 58 -75 10 0 37 -20 61 -45 61 -62 91 -62 159 3 l51 49 -23 26 c-28 32 -41
34 -65 7 -18 -20 -18 -20 -47 7 -33 31 -34 40 -11 65 16 18 15 20 -14 50 -17
17 -36 27 -42 24 -17 -11 -13 -20 11 -31 28 -13 33 -29 13 -48 -22 -22 -20
-29 23 -70 44 -43 52 -44 77 -17 14 15 21 17 32 9 7 -6 13 -15 13 -20 0 -16
-71 -79 -88 -79 -22 0 -60 26 -99 68 -16 17 -39 32 -49 32 -29 0 -46 15 -43
36 2 11 -1 29 -5 42 -13 40 46 86 60 47 6 -14 34 -22 34 -9 0 8 -43 43 -52 44
-4 0 -22 -13 -40 -29z"/>
<path d="M993 1972 c-20 -3 -38 -21 -97 -92 -10 -13 -21 -42 -23 -64 -6 -50 5
-64 100 -130 l67 -47 54 45 c29 26 64 66 77 91 23 44 23 45 6 77 -22 39 -105
110 -139 118 -13 3 -33 4 -45 2z m99 -49 c47 -39 78 -80 78 -105 0 -18 -51
-87 -65 -88 -5 0 -23 13 -40 28 -51 48 -85 66 -97 54 -14 -14 8 -62 27 -62 6
0 20 -8 31 -18 11 -11 25 -21 32 -23 10 -3 10 -9 -1 -23 -13 -18 -16 -18 -68
17 -58 39 -112 90 -109 104 6 20 82 123 102 137 34 24 59 19 110 -21z"/>
<path d="M1024 1876 c-6 -17 31 -55 54 -56 18 0 15 25 -5 42 -32 27 -43 30
-49 14z"/>
<path d="M4700 1790 c-25 -16 -61 -42 -80 -58 l-34 -30 19 -36 c11 -20 23 -36
27 -36 5 0 8 -12 8 -26 0 -53 49 -104 100 -104 25 0 77 32 96 59 8 11 22 21
31 21 8 0 28 10 45 21 35 25 34 28 -35 131 -67 99 -98 110 -177 58z m129 -27
c38 -46 85 -133 76 -141 -3 -3 -11 0 -16 8 -8 12 -9 11 -7 -5 2 -15 -4 -21
-21 -23 -13 -2 -40 -21 -61 -43 -43 -46 -67 -49 -109 -13 -49 41 -37 90 34
134 19 12 35 28 35 36 0 23 -12 18 -95 -40 -27 -20 -28 -20 -42 0 -13 17 -11
22 25 54 101 92 129 97 181 33z"/>
<path d="M4768 1649 c-28 -21 -38 -59 -15 -59 6 0 26 11 42 24 27 22 28 26 15
40 -13 13 -18 13 -42 -5z"/>
<path d="M1268 1722 c-24 -22 -32 -38 -32 -65 -1 -27 -5 -37 -17 -37 -9 0 -24
-16 -35 -35 l-18 -35 34 -30 c19 -16 40 -29 46 -30 6 0 19 -9 28 -19 59 -65
141 -60 177 11 13 25 18 49 15 64 -4 14 -2 24 4 24 6 0 19 14 30 32 18 30 18
34 3 50 -9 10 -21 18 -26 18 -6 0 -18 6 -26 14 -23 20 -116 66 -135 66 -9 0
-30 -13 -48 -28z m153 -34 c70 -44 85 -68 52 -86 -13 -8 -29 -2 -67 24 -57 38
-66 41 -66 19 0 -8 18 -26 40 -40 72 -45 82 -80 36 -132 -29 -34 -69 -29 -125
14 -9 7 -35 26 -59 43 -38 27 -41 32 -28 46 14 13 20 12 57 -13 75 -50 90 -56
102 -43 9 9 4 19 -23 41 -19 16 -40 29 -47 29 -17 0 -45 57 -38 79 9 31 45 61
71 61 15 0 57 -19 95 -42z"/>
<path d="M4260 1622 c-68 -34 -95 -53 -97 -67 -1 -12 0 -14 3 -5 6 18 165 98
211 106 59 11 97 -32 148 -168 27 -74 12 -97 -107 -157 l-96 -49 -45 77 c-24
42 -54 97 -68 124 -13 26 -27 47 -31 47 -8 0 19 -65 37 -90 6 -8 20 -35 31
-60 10 -25 29 -64 42 -87 l23 -41 72 35 c197 95 213 133 125 290 -63 111 -104
118 -248 45z"/>
<path d="M1663 1600 c-10 -11 -25 -20 -35 -20 -21 0 -55 -67 -41 -81 6 -6 2
-26 -13 -57 -28 -56 -30 -103 -6 -124 33 -30 121 -67 129 -55 34 52 37 77 9
77 -8 0 -19 7 -26 15 -11 13 -10 22 4 51 15 32 19 35 46 29 26 -6 31 -3 43 27
13 30 13 34 -6 49 -14 12 -18 23 -14 39 6 23 -15 49 -38 49 -5 0 -2 -4 8 -10
14 -8 17 -18 12 -39 -5 -21 -1 -31 14 -42 14 -10 18 -21 14 -36 -5 -19 -10
-22 -39 -16 -32 6 -34 4 -55 -39 -24 -49 -20 -76 11 -84 22 -6 26 -23 9 -40
-21 -21 -119 34 -119 66 0 9 11 43 24 76 15 36 21 64 16 70 -14 17 0 55 21 55
10 0 22 6 26 13 4 8 16 18 27 24 12 7 15 13 8 17 -7 4 -19 -2 -29 -14z"/>
<path d="M4312 1563 c-27 -13 -32 -20 -28 -39 9 -33 67 -153 78 -160 4 -3 27
5 51 18 49 27 57 55 29 108 -49 95 -66 105 -130 73z m95 -62 c8 -18 13 -34 11
-36 -7 -7 -64 -7 -80 0 -10 4 -18 15 -18 24 0 9 -5 22 -11 28 -9 9 -3 17 22
32 32 20 35 20 48 3 7 -9 20 -32 28 -51z m28 -61 c3 -6 -9 -19 -27 -30 -31
-19 -34 -19 -45 -3 -22 29 -17 33 49 40 10 1 20 -2 23 -7z"/>
<path d="M3750 1428 c-44 -12 -52 -19 -40 -38 8 -13 10 -13 10 1 0 20 20 29
61 29 18 0 28 4 24 10 -7 12 -8 11 -55 -2z"/>
<path d="M3530 1380 c0 -5 6 -10 14 -10 10 0 17 -16 21 -47 6 -48 22 -139 30
-180 3 -13 14 -23 27 -25 42 -6 31 -43 -16 -52 -61 -11 -76 12 -107 168 -19
95 -25 115 -32 105 -9 -9 42 -240 57 -263 21 -33 53 -40 106 -26 40 11 42 13
36 42 -3 17 -6 34 -6 39 0 4 -10 9 -22 11 -24 3 -22 -4 -59 173 -11 55 -22 74
-41 75 -5 0 -8 -4 -8 -10z"/>
<path d="M3465 1369 c-11 -16 -2 -17 30 -3 l30 13 -27 1 c-15 0 -30 -5 -33
-11z"/>
<path d="M3811 1364 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M2122 1340 c-21 -23 -39 -75 -48 -142 -9 -63 19 -94 106 -114 129
-31 155 -19 184 87 32 114 13 149 -94 173 -92 21 -125 20 -148 -4z m129 -6
c92 -21 113 -42 105 -106 -8 -56 -29 -110 -51 -128 -13 -11 -31 -12 -92 -3
-98 14 -128 40 -124 107 4 71 47 144 84 146 4 0 40 -7 78 -16z"/>
<path d="M2184 1263 c-3 -10 -10 -28 -15 -41 -17 -42 -11 -60 24 -71 46 -15
65 -6 77 37 15 55 13 68 -15 80 -37 17 -65 15 -71 -5z m70 -11 c3 -5 3 -25 -1
-45 -5 -33 -9 -37 -34 -37 -31 0 -36 17 -23 68 6 22 47 32 58 14z"/>
<path d="M3721 1350 c-1 -27 48 -192 64 -216 18 -28 53 -39 100 -30 42 8 48
16 39 60 -5 28 -11 35 -32 38 -23 3 -28 11 -44 68 l-18 65 6 -54 c6 -61 28
-111 48 -111 19 0 30 -32 14 -42 -20 -12 -75 -9 -90 5 -7 8 -21 40 -32 73 -31
98 -55 160 -55 144z"/>
<path d="M2557 1337 c-5 -13 -2 -14 16 -6 13 5 47 6 82 2 56 -7 60 -10 63 -35
2 -18 -2 -28 -10 -29 -7 0 -29 -1 -48 -2 -42 -2 -51 -32 -10 -32 16 0 27 -7
31 -20 9 -33 -1 -45 -40 -45 l-37 0 -13 -73 c-12 -66 -15 -73 -35 -71 -11 1
-26 3 -33 3 -8 1 -10 24 -6 80 4 53 2 80 -6 85 -18 11 -13 42 10 58 15 9 20
21 16 38 -4 24 -5 24 -12 3 -4 -11 -15 -23 -26 -26 -15 -4 -19 -14 -19 -51 0
-27 5 -46 11 -46 8 0 9 -24 4 -79 l-7 -78 46 -7 c25 -4 50 -5 55 -2 4 3 11 32
15 63 8 73 13 81 56 85 34 3 35 4 38 50 2 34 7 46 16 42 15 -6 32 74 19 87 -4
4 -44 11 -89 14 -69 6 -82 5 -87 -8z"/>
<path d="M3210 1331 c0 -6 7 -8 15 -5 11 5 25 -16 54 -78 21 -47 42 -96 46
-109 4 -13 13 -31 20 -39 7 -8 15 -24 17 -35 3 -11 9 -28 13 -37 6 -15 1 -18
-32 -18 -30 0 -40 5 -48 23 -9 19 -17 22 -75 22 -58 0 -66 -2 -76 -24 -16 -31
-39 -44 -63 -36 -19 6 -20 25 -1 70 4 11 18 58 29 105 37 143 39 148 69 153
25 4 25 4 -4 6 -37 1 -31 13 -90 -178 -56 -183 -56 -182 -1 -177 23 2 48 4 55
5 7 1 17 14 23 29 9 25 15 29 54 30 37 2 47 -2 61 -23 15 -22 23 -25 71 -24
29 1 56 6 59 10 5 8 -48 129 -112 254 -30 58 -47 81 -62 83 -12 2 -22 -1 -22
-7z"/>
<path d="M3190 1185 c-6 -14 -10 -37 -10 -51 0 -20 5 -24 29 -24 40 0 45 13
25 55 -22 47 -32 51 -44 20z"/>
</g>
</svg>


    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
